import { mapUnitsI18nObject } from './mapUnitsI18nObject';
import { type UnitLabelType, type UnitsLanguage } from './types';
import { useQueryUnits } from './useQueryUnits';

type P = {
  language?: UnitsLanguage;
  label?: UnitLabelType | undefined;
};

/**
 * Syntactic sugar for getting all defined UN/CEFACT units and their translations in the language of the user using the useQueryUnits hook.
 * @param params - The parameters for the hook.
 * @param params.label - The long or short version of the translation to return (defaults to 'fullName').
 * @param params.language - The language to fetch the units in (defaults to 'DE').
 * @returns The query result containing all UN/CEFACT units and their translations.
 */
export const useUnitTranslations = ({ label, language = 'DE' }: P) => {
  const { data: units } = useQueryUnits(
    { language },
    { select: (data) => mapUnitsI18nObject(data, label) },
  );

  return units ?? {};
};
